export const staticPages = {
  privacy_policy: () => "https://app.circle.so/cookie-policy",
};
